import { Button } from '@playcastdotio/Shadcn';
import { Link } from 'react-router-dom';
import { download } from '../../api/api';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows } from '@fortawesome/free-brands-svg-icons';
import config from '../../config.json';

export const Header = () => {
  const hostname = window.location.hostname;

  const links = [
    {
      name: 'Changelog',
      url: '/changelog',
    },
    {
      name: 'News',
      url: '/news',
    },
    {
      name: 'FAQs',
      url: '/faqs',
    },
    {
      name: 'UX Testers',
      url: '/ux-testers',
    },
    {
      name: 'Remote Host',
      url: config.DASHBOARD_URL,
    },
  ];

  useEffect(() => {
    const links = document.querySelectorAll('#mobile-menu-links a');
    const checkbox = document.querySelector('#mobile-menu') as HTMLInputElement;

    links.forEach((link) => {
      link.addEventListener('click', () => {
        if (checkbox) {
          checkbox.checked = false;
        }
      });
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', () => {
          checkbox.checked = false;
        });
      });
    };
  }, []);

  return (
    <>
      {/* Desktop header */}
      <header className='hidden md:flex w-full sticky top-0 m-0 pt-2 px-4 border-b-2 border-purple-900 align-middle bg-header text-content-text'>
        <div id='logo' className='flex flex-row flex-grow align-middle gap-x-2 p-2'>
          <img src='/images/playcast_logo-96x96.png' alt='Logo' className='w-12 h-12' />
          <h1 className='md:pt-2 text-content-text-headline text-3xl font-bold font-headline'>
            <Link to='/'>Playcast</Link>
          </h1>
        </div>

        <nav id='large menu' className='hidden md:flex flex-grow align-middle md:gap-x-2 lg:gap-x-6 xl:gap-x-8 p-2 justify-end'>
          <ul className='flex flex-row md:gap-x-4 lg:gap-x-8 xl:gap-x-10 md:pt-3.5 lg:pt-3 align-middle h-min md:text-lg lg:text-xl'>
            {links.map((link) => (
              <li key={link.name} className='hover:text-primary-hover focus:text-primary-hover active:text-primary-active'>
                <Link to={link.url}>{link.name}</Link>
              </li>
            ))}
          </ul>
          <Button className='rounded-full flex space-x-2' onClick={download}>
            <FontAwesomeIcon icon={faWindows} className='text-2xl' />
            <span>Download</span>
          </Button>
        </nav>
      </header>

      {/* Mobile header */}
      <header className='flex md:hidden w-full sticky top-0 m-0 pt-2 px-4 border-b-2 border-purple-900 align-middle bg-header text-content-text'>
        <nav id='mobile menu' className='flex justify-start align-middle gap-x-2 p-2'>
          <label className='relative z-40 cursor-pointer px-3 py-6' htmlFor='mobile-menu'>
            <input className='peer hidden' type='checkbox' id='mobile-menu' />
            <div className="relative z-50 block h-[1px] w-7 bg-white bg-transparent content-[''] before:absolute before:top-[-0.35rem] before:z-50 before:block before:h-full before:w-full before:bg-white before:transition-all before:duration-200 before:ease-out before:content-[''] after:absolute after:left-0 after:bottom-[-0.35rem] after:block after:h-full after:w-full after:bg-white after:transition-all after:duration-200 after:ease-out after:content-[''] peer-checked:bg-transparent before:peer-checked:top-0 before:peer-checked:w-full before:peer-checked:rotate-45 before:peer-checked:transform after:peer-checked:bottom-0 after:peer-checked:w-full after:peer-checked:-rotate-45 after:peer-checked:transform"></div>
            <div className='fixed inset-0 z-40 hidden h-full w-full bg-black/50 backdrop-blur-sm peer-checked:block'>&nbsp;</div>
            <div className='fixed top-0 left-0 z-40 h-full w-full -translate-x-full overflow-y-auto overscroll-y-none transition duration-500 peer-checked:translate-x-0'>
              <div id='mobile-menu-links' className='float-left min-h-full w-[85%] bg-purple-900 px-6 pt-12 shadow-2xl'>
                <menu>
                  <ul className='flex flex-col gap-y-8 py-12 align-middle h-min text-2xl'>
                    {links.map((link) => (
                      <li key={link.url} className='flex-row hover:text-primary-hover focus:text-primary-hover active:text-primary-active'>
                        <Link to={link.url}>{link.name}</Link>
                      </li>
                    ))}
                  </ul>
                </menu>
              </div>
            </div>
          </label>
        </nav>

        <div id='mobile logo' className='flex flex-row flex-grow align-middle justify-center gap-x-2 pt-3'>
          <img src='/images/playcast_logo-96x96.png' alt='Logo' className='w-10 h-10' />
          <h1 className='md:pt-2 text-content-text-headline text-2xl font-bold font-headline pt-1'>
            <Link to='/'>Playcast</Link>
          </h1>
        </div>
      </header>
    </>
  );
};
